import { useCallback, useEffect, useRef, useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { useWindowSize } from 'react-use';
import { useResizeObserver } from '../../lib/hooks';
export function usePopoverPosition() {
    const buttonRef = useRef(null);
    const wrapperRef = useRef(null);
    const panelRef = useRef(null);
    const { width: windowWidth } = useWindowSize();
    const [positionTop, setPositionTop] = useState(0);
    const [positionLeft, setPositionLeft] = useState(0);
    const getPosition = useCallback(() => {
        if (!buttonRef.current || !wrapperRef.current)
            return { top: 0, left: 0 };
        const buttonBox = buttonRef.current.getBoundingClientRect();
        const wrapperBox = wrapperRef.current.getBoundingClientRect();
        const panelBox = panelRef?.current?.getBoundingClientRect();
        const top = Math.max(0, buttonBox.bottom - wrapperBox.top);
        const left = buttonBox.left - wrapperBox.left;
        if (panelBox && panelBox.right > window.innerWidth) {
            return { top, left: left - (panelBox.right - window.innerWidth) };
        }
        return { top, left };
    }, []);
    const createCallbackRef = useCallback((node, ref) => {
        if (node !== null) {
            ref.current = node;
            unstable_batchedUpdates(() => {
                setPositionTop(getPosition().top);
                setPositionLeft(getPosition().left);
            });
        }
    }, [getPosition, setPositionTop, setPositionLeft]);
    const setButtonRef = useCallback((node) => createCallbackRef(node, buttonRef), [createCallbackRef]);
    const setWrapperRef = useCallback((node) => createCallbackRef(node, wrapperRef), [createCallbackRef]);
    const setPanelRef = useCallback((node) => createCallbackRef(node, panelRef), [createCallbackRef]);
    useEffect(() => unstable_batchedUpdates(() => {
        setPositionTop(getPosition().top);
        setPositionLeft(getPosition().left);
    }), [setPositionTop, setPositionLeft, getPosition, windowWidth]);
    useResizeObserver(buttonRef, () => requestAnimationFrame(() => {
        unstable_batchedUpdates(() => {
            setPositionTop(getPosition().top);
            setPositionLeft(getPosition().left);
        });
    }));
    const position = { top: positionTop, left: positionLeft };
    return {
        position,
        buttonRef,
        wrapperRef,
        panelRef,
        setButtonRef,
        setWrapperRef,
        setPanelRef,
    };
}
//# sourceMappingURL=usePopoverPosition.js.map